/* Horizontal rows ([data-uc-scroll]) get one pair of previous/next buttons per section,
   placed in the section head. The buttons act on whichever row is currently visible
   (tabbed sections have one row per tab). Their space is always reserved so switching
   tabs never shifts the tab buttons; they are only shown when the visible row overflows.
   Hidden below 750px, where rows are swiped. */
(() => {
  if (window.__ucScrollReady) return;
  window.__ucScrollReady = true;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const icon = (dir) => `<svg width="16" height="16" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="${dir < 0 ? 'M15 5l-7 7 7 7' : 'M9 5l7 7-7 7'}" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>`;

  const setupSection = (section, rows) => {
    if (section.dataset.ucScrollReady) return;
    section.dataset.ucScrollReady = '1';
    const head = section.querySelector('.uc-head');
    const heading = section.querySelector('h2');
    const label = heading ? heading.textContent.trim() : 'row';
    const nav = document.createElement('div');
    nav.className = 'uc-scroll__nav';
    const mk = (dir) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'uc-scroll__btn';
      b.setAttribute('aria-label', `Scroll ${label} ${dir < 0 ? 'left' : 'right'}`);
      b.innerHTML = icon(dir);
      return b;
    };
    const prev = mk(-1);
    const next = mk(1);
    nav.append(prev, next);
    if (head) head.appendChild(nav); else rows[0].parentElement.insertBefore(nav, rows[0]);

    const active = () => rows.find((r) => !r.closest('[hidden]') && r.offsetParent !== null) || null;
    const step = (r) => Math.max(r.clientWidth * 0.8, 200);
    const go = (dir) => {
      const r = active();
      if (r) r.scrollBy({ left: dir * step(r), behavior: reduceMotion.matches ? 'auto' : 'smooth' });
    };
    prev.addEventListener('click', () => go(-1));
    next.addEventListener('click', () => go(1));

    const update = () => {
      const r = active();
      const overflow = !!r && r.scrollWidth > r.clientWidth + 8;
      nav.classList.toggle('is-visible', overflow);
      prev.disabled = !overflow || r.scrollLeft <= 2;
      next.disabled = !overflow || r.scrollLeft + r.clientWidth >= r.scrollWidth - 2;
    };
    rows.forEach((r) => {
      r.addEventListener('scroll', update, { passive: true });
      if ('ResizeObserver' in window) new ResizeObserver(update).observe(r);
    });
    window.addEventListener('resize', update);
    document.addEventListener('uc:tabchange', () => requestAnimationFrame(update));
    update();
  };

  const init = () => {
    const bySection = new Map();
    document.querySelectorAll('[data-uc-scroll]').forEach((row) => {
      const section = row.closest('section') || row.parentElement;
      if (!bySection.has(section)) bySection.set(section, []);
      bySection.get(section).push(row);
    });
    bySection.forEach((rows, section) => setupSection(section, rows));
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
